import React from 'react';
import {
  BrowserRouter as Router,
  Route,
  Redirect
} from 'react-router-dom';
import CSSTransitionGroup from 'react-transition-group/CSSTransitionGroup';
import classNames from 'classnames';
import Pace from 'pace-progress';
// import createHistory from 'history/createBrowserHistory';

import Test from '../containers/Test';
import TestExplanation from '../containers/TestExplanation';
import FinalResult from '../containers/FinalResult';

import Ga from './Ga';
import Home from './Home';
import Tape from './Tape';
import ProgressBar from './ProgressBar';
import QuestionnaireTitle from './QuestionnaireTitle';

import '../styles/index.sass';

class Root extends React.PureComponent {
  componentDidMount() {
    Pace.start({
      ajax: false,
      restartOnPushState: false
    });
  }

  render() {
    return (
      <Router>
        <Ga pace={Pace}>
          <div className="container full-width full-height">
            <Route exact path="/" component={Home} />
            <Redirect from="*" to="/" />
            <Route path="/explanation" component={TestExplanation} />
            <Route path="/tape" component={Tape} />
            <Route path="/final" component={FinalResult} />
            <Route
              render={({ location }) => {
                const [, , id] = location.pathname.split('/');
                const testId = (id === 'wait') ? '9' : id;
                const isRegularTest = (id !== 'wait' && id !== '10');

                if (!testId) return null;

                return (
                  <div>
                    <ProgressBar testId={testId} />
                    <div
                      className={classNames(
                        'container',
                        'full-width'
                      )}
                    >
                      {
                        isRegularTest && <QuestionnaireTitle />
                      }
                      <div style={{ position: 'relative' }}>
                        <CSSTransitionGroup
                          transitionName="slide"
                          transitionAppearTimeout={500}
                          transitionEnterTimeout={500}
                          transitionLeaveTimeout={500}
                        >
                          <Route
                            location={location}
                            key={location.key}
                            path="/test/:testId"
                            component={Test}
                          />
                        </CSSTransitionGroup>
                      </div>
                    </div>
                  </div>
                );
              }}
            />
          </div>
        </Ga>
      </Router>
    );
  }
}

export default Root;



// WEBPACK FOOTER //
// ./app/components/App.js